module.exports = __webpack_public_path__ + "img/app_image.5e201ec0.png";